import { faColumns3 } from '@fortawesome/pro-light-svg-icons'
import { Fragment, useCallback } from 'react'
import { ButtonSecondary } from '../../../../../../../../baseComponents/Button'
import TwinIcon from '../../../../../../../../baseComponents/TwinIcon'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import ModalConfigStatsByProduct from '../ModalConfigStatsByProduct'
import { ButtonsLoadFiltersStateFull } from '../../../../../../../../baseComponents/Button/ButtonLoadFilter'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import { getTableSelectedColumns, SelectedColumnsAndFilters } from '../../../../../../../../utils/hooks/useConfigColumns'
import useEditDeleteModal, { SetEditDeleteModalTy } from '../../../../../../../../utils/hooks/useEditDeleteModal'
import ModalConfigStatsByEmployee from '../ModalConfigStatsByEmployee'
import { TypeSellTableNameTy } from '../types'

interface ButtonModalConfigStatsEmployeeProps extends ButtonModalConfigStatsPropsLogic {
    selectedColumnsAndFilters: SelectedColumnsAndFilters
    typeTableName: TypeSellTableNameTy
}

export const ButtonModalConfigStatsEmployee: React.FC<ButtonModalConfigStatsEmployeeProps> = ({ selectedColumnsAndFilters, setSelectedColumnsAndFilters, typeTableName, ...logic }) => {
    const { setOpenModal, openModal } = useEditDeleteModal()
    const tableName = 'employee_'+typeTableName+'_config_stats'
    const defaultValues = getTableSelectedColumns(tableName, [])
    return (
        <Fragment>
            <ButtonModalConfigStatsBase {...logic} {...{ defaultValues, selectedColumnsAndFilters, setOpenModal, setSelectedColumnsAndFilters, tableName }} />
            {openModal?.type === 'edit' ? <ModalConfigStatsByEmployee setOpened={() => setOpenModal(null)} selectedColumnsAndFilters={selectedColumnsAndFilters} setSelectedColumnsAndFilters={setSelectedColumnsAndFilters} {...{ typeTableName }}/> : null}
        </Fragment>
    )
}

interface ButtonModalConfigStatsProductProps extends ButtonModalConfigStatsPropsLogic {
    typeTableName: TypeSellTableNameTy
    selectedColumnsAndFilters: SelectedColumnsAndFilters
}

export const ButtonModalConfigStatsProduct: React.FC<ButtonModalConfigStatsProductProps> = ({ selectedColumnsAndFilters, setSelectedColumnsAndFilters, typeTableName, ...logic }) => {
    const { setOpenModal, openModal } = useEditDeleteModal()
    const tableName = typeTableName+'_product_config_stats'
    const defaultValues = getTableSelectedColumns(tableName, [])
    return (
        <Fragment>
            <ButtonModalConfigStatsBase {...logic} {...{defaultValues, selectedColumnsAndFilters, setOpenModal, setSelectedColumnsAndFilters, tableName}} />
            {openModal?.type === 'edit' ? <ModalConfigStatsByProduct setOpened={() => setOpenModal(null)} {...{ typeTableName, selectedColumnsAndFilters, setSelectedColumnsAndFilters }} /> : null}
        </Fragment>
    )
}
interface ButtonModalConfigStatsBaseProps extends ButtonModalConfigStatsPropsLogic {
    selectedColumnsAndFilters: SelectedColumnsAndFilters
    tableName: string
    defaultValues: SelectedColumnsAndFilters
    setOpenModal: SetEditDeleteModalTy
}

const ButtonModalConfigStatsBase: React.FC<ButtonModalConfigStatsBaseProps> = ({setSelectedColumnsAndFilters, selectedColumnsAndFilters, tableName, defaultValues, setOpenModal,  ...logic }) => {
    const { onChangeFilter } = useButtonModalConfigStatsLogic({ setSelectedColumnsAndFilters, ...logic })
    return (
        <div className='flex gap-10 ml-auto'>
            <ButtonsLoadFiltersStateFull allowCreate={true} selectedFilters={selectedColumnsAndFilters} onChangeFilter={onChangeFilter} tableName={'table_' + tableName} defaultValues={defaultValues} />
            <ButtonSecondary onClick={() => setOpenModal({ type: 'edit', allRowData: {} })}>
                <TwinIcon icon={faColumns3} />
                <span className='ml-10'><TwinTrans transKey='configStats'>Configurar estadísticas</TwinTrans></span>
            </ButtonSecondary>
        </div>
    )
}

interface ButtonModalConfigStatsPropsLogic {
    setSelectedColumnsAndFilters: React.Dispatch<React.SetStateAction<SelectedColumnsAndFilters>>
}

const useButtonModalConfigStatsLogic = ({ setSelectedColumnsAndFilters }: ButtonModalConfigStatsPropsLogic) => {
    const onChangeFilter = useCallback((json: TwinDictionary) => {
        setSelectedColumnsAndFilters({ filters: json?.value?.filters || {}, selectedColumns: json?.value?.selectedColumns || {}, id: json?.id, name: json?.name, order: json?.value?.order || {} })

    }, [setSelectedColumnsAndFilters])

    return { onChangeFilter }
}
